import { useState } from "react";
import RdvCaracs, { RdvCaracsCallbacks } from "./RdvCaracs";
import EditRdvButtonsCommit from "./EditRdvButtonsCommit";
import CancelRdvsButtonsCommit from "./CancelRdvButtons";
import { formaters } from "vincent-utils";
import { ExistingPatient } from "cadendar-shared";
import { DateTime } from "luxon";
import _ from "underts";
import { EditRdvState } from "../containers/EditRdvContainer";
import { AppointmentsDTO } from "cadendar-trpc-server";
import LogosLink from "../../patients/components/LogosLink";
import { HiArrowLongRight } from "react-icons/hi2";
import {Button} from "@/components/ui/button";
import { usePreferences } from "../../main/state/globalState";
import { openPatientFile } from "../../patients/openPatientFile";

interface EditRdvProps {
  rdvCaracsState: EditRdvState;
  hmPossibles: { hour: number; minute: number }[];
  dureesPossibles: number[];
  remindersCheckBoxEnabled: boolean;
  confirmCheckBoxEnabled: boolean;
  onSaveRdv: () => void;
  onCancelRdvEdit: () => void;
  onDeleteWithoutLogging: () => void;
  onCancelWithLogging: () => void;
  onAutoDelete: () => void;
  onPostPone: () => void;
  isSecretary: boolean;
  rdvCaracsCallbacks: RdvCaracsCallbacks;
  users: { id: string; messagename: string; username: string }[];
  rdv: AppointmentsDTO;
  patient: ExistingPatient | null; //on peut être en train d'effacer une plage fermée
}

const EditRdv = (props: EditRdvProps) => {
  const { rdv, patient } = props;
  const preferences = usePreferences();
  // console.log("EditRdv", JSON.stringify(rdv, null, 2));

  const createdOnDate = _.first(rdv.logs)?.timestamp;
  // console.log("typeof createdOnDate", typeof createdOnDate);
  const createdOn =
    (createdOnDate &&
      DateTime.fromJSDate(createdOnDate).toLocaleString({
        weekday: "short",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })) ||
    "";

  const editedOnDate =
    rdv.logs && rdv.logs.length > 1 && _.last(rdv.logs)?.timestamp;
  const editedOn =
    (editedOnDate &&
      DateTime.fromJSDate(editedOnDate).toLocaleString({
        weekday: "short",
        month: "short",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })) ||
    "";
  const createdById =
    _.first(rdv.logs)?.editor_doc || _.first(rdv.logs)?.editor_sec;
  const createdBy =
    props.users.find((u) => u.id === createdById)?.messagename || "";
  const editedById =
    _.last(rdv.logs)?.editor_doc || _.last(rdv.logs)?.editor_sec;

  const editedBy =
    props.users.find((u) => u.id === editedById)?.messagename || "";

  const recordMode = _.first(rdv.logs)?.mode || "";

  const {
    onSaveRdv,
    onCancelRdvEdit,
    onDeleteWithoutLogging,
    onCancelWithLogging,
    onAutoDelete,
    onPostPone,
    isSecretary,
  } = props;

  const [showCancel, setShowCancel] = useState(false);

  const misAJourString = editedOn
    ? "Mis à jour le : " + editedOn + " par " + editedBy
    : null;
  const nom = patient?.name;
  const prenom = patient?.forename;

  const npDisplay = (nom &&
    prenom &&
    formaters.formatNomPrenomForDisplay({ nom, prenom })) || {
    nom: "PAS DE PATIENT SéLECTIONNé".toLocaleUpperCase(),
    prenom: "",
  };

  const handleOpenPatientFile = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!patient?.id) {
      return;
    }

    openPatientFile({
      patientId: patient.id,
      allowSingleWindow: preferences?.single_patient_file_window ?? true,
    });
  };

  const cancelButtons = showCancel ? (
    <CancelRdvsButtonsCommit
      onSimpleDelete={onDeleteWithoutLogging}
      onCancel={onCancelWithLogging}
      onAutoDelete={onAutoDelete}
      onPostPone={onPostPone}
      isSecretary={isSecretary}
    />
  ) : (
    <span />
  );

  return (
    <div className="w-[500px]">
      <div className="mb-2.5 flex items-center justify-center gap-[5px] rounded-[5px] bg-[#545454] text-center text-white">
        <div>{npDisplay.nom + " " + npDisplay.prenom}</div>
        <div className="flex items-center gap-2">
          <LogosLink
            fileNumber={patient?.logos_file_number || null}
            patientId={patient?.id || ""}
          />
          {patient?.id ? (
            <Button
              type="button"
              variant="ghost"
              onClick={handleOpenPatientFile}
            >
              Dossier
              <HiArrowLongRight />
            </Button>
          ) : null}
        </div>
      </div>
      <div>
        <div>
          <div className="mt-1 text-center text-gray-500">
            Créé le : {createdOn} par {createdBy}{" "}
            {" (" +
              (recordMode === "manuel" ? "manuellement" : "automatiquement") +
              ")"}
            <div className="mt-1 text-center text-gray-500">{misAJourString}</div>
          </div>
        </div>
        <div></div>
      </div>
      <div>
        <RdvCaracs
          rdvsCaracsState={{
            ...props.rdvCaracsState,
            object: props.rdvCaracsState.object || "",
            hmPossibles: props.hmPossibles,
            dureesPossibles: props.dureesPossibles,
            remindersCheckBoxEnabled: props.remindersCheckBoxEnabled,
            confirmCheckBoxEnabled: props.confirmCheckBoxEnabled,
          }}
          rdvsCaracsCallbacks={props.rdvCaracsCallbacks}
        />
      </div>
      <div>{cancelButtons}</div>
      <div>
        <EditRdvButtonsCommit
          onSaveRdv={onSaveRdv}
          onCancelRdvEdit={onCancelRdvEdit}
          onDeleteWithoutLogging={onDeleteWithoutLogging}
          onCancelWithLogging={onCancelWithLogging}
          onAutoDelete={onAutoDelete}
          onPostPone={onPostPone}
          isSecretary={isSecretary}
        />
      </div>
    </div>
  );
};
export default EditRdv;
